module.exports = __webpack_public_path__ + "images/home/signup-guide-arrow-da5e926a844bd96ec7a7c742be644ecb.png";